import * as React from "react";
import { useState } from "react";
import { IdStyles } from "../../../less/IdStyles";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { ButtonHudNormal } from "../common/ButtonHudNormal";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { TextInput } from "../text-input/TextInput";
export var SearchInput = React.memo(function (_a) {
    var onClick = _a.onClick, inputTextPlaceholderLoca = _a.inputTextPlaceholderLoca, onResolveSearchNotFound = _a.onResolveSearchNotFound, isSearchNotFound = _a.isSearchNotFound;
    var _b = useState(""), searchText = _b[0], setSearchText = _b[1];
    var submitSearch = function () { return onClick(searchText); };
    var onChange = function (text) {
        setSearchText(text);
        if (isSearchNotFound && onResolveSearchNotFound != undefined) {
            onResolveSearchNotFound();
        }
    };
    return (React.createElement("div", { className: "flex flex--aligned flex--around " + IdStyles.CoopSearchContainer },
        React.createElement(TextInput, { style: IdStyles.CoopSearchNameInput, placeholder: utilLoca.get(inputTextPlaceholderLoca), onChange: onChange, value: searchText, onSubmit: submitSearch }),
        React.createElement(ButtonHudNormal, { onClick: submitSearch, disabled: searchText.length === 0 },
            React.createElement(Icon, { icon: IdIcon.SearchIcn, styleId: IdStyles.IconMedium }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/search-input/SearchInput.tsx
// module id = 919
// module chunks = 3